<template>
  <div>
    <div class="alertNotify" v-if="showAlarmNotify">
      <div class="notifyGroup">
        <div class="cusNotifyBox" @click="goDetailInfo" style="cursor: pointer">
          <div class="notifyLevel backRed"></div>
          <div class="notifyType">{{ getType(alarmInfo.AlertType) }}</div>
          <div class="notifyContent">
            {{ alarmInfo.Content }}
          </div>
        </div>
        <div class="closebtn el-icon-close" @click="closeNotify"></div>
      </div>
    </div>
    <audio
      id="audio"
      controls="controls"
      hidden
      src="/lib/audio/ding.mp3"
      ref="audio"
    />
    <audio
      id="audio2"
      controls="controls"
      hidden
      loop
      src="/lib/audio/alarm.mp3"
      ref="audio2"
    />
  </div>
</template>

<script>
import MyApis from "../../api/src/earlyMsg.js";
import MapCenterApi from "../../api/src/MapCenter.js";
import { Notification } from "element-ui";
import CircleRippleMaterialProperty from "../../utils/src/addRadarScan";
import { queryDevice } from "../../request/msgApi";
export default {
  name: "WarningNotification",
  // controller: "UI",
  // action: "ElaryWarningInfoList",

  data() {
    return {
      showClose: true,

      toUrl: "/plugin/emergency/ui/onemap",
      loadingText: "加载中...",
      mapInstance: null,
      dialogVisible1: false,
      dialogVisible2: false,
      marker: null,
      lat: "",
      lng: "",
      center: [],
      center2: [],
      alarmInfo: {},
      AlerteLevelArr: [],
      AlertTypeArr: [],
      isHavePosition: false,
      isVideoMonitorDialogVisible: false,
      streamType: 1, //0 - 主码流；1 - 子码流
      autoplay: true,
      cameraId: "",
      cameraName: "",
      deviceInfo: {},
      dialogAlertInfoVisible: false,
      isSoSMonitorDialogVisible: false,
      ResourcesId: "",
      showAlarmNotify: false,
      alarmEntity: null,
      isEmergency: false,
    };
  },
  props: ["warningId"],
  // props:{
  //    warningId:String
  // },
  watch: {
    warningId: {
      // eslint-disable-next-line no-unused-vars
      handler: function (val, oldVal) {
        if (val !== oldVal && val != "") {
          this.search();

          this.$store.state.isShowWarningBox = true;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created: function () {
    this.alarmLevel();
    this.getAlarmType();
    // this.warningId = "f090afae-ae71-4ef4-9bdd-6af610aa5fb3";
  },
  mounted: function () {
    //如果是应急平台则不弹出消息弹窗
    if (localStorage.getItem("isEmergency") == "true") {
      this.isEmergency = true;
    } else {
      this.isEmergency = false;
    }
    //  debugger;
    // this.onDrawMap();
  },
  computed: {
    isShowWarningBox() {
      return this.$store.state.isShowWarningBox;
    },
  },
  methods: {
    showNotify(levelStyle, type, content) {
      Notification({
        dangerouslyUseHTMLString: true,
        duration: 3000,
        customClass: "cusNotify",
        showClose: false,
        message:
          "<div  class='cusNotifyBox'>" +
          "<div  class='notifyLevel' " +
          levelStyle +
          "</div>" +
          "<span class='notifyType'>" +
          type +
          "</span>" +
          "<span  class='notifyContent'>" +
          content +
          "</span>" +
          "</div>",
      });
      this.playMusic();
    },
    playMusic() {
      this.$nextTick(() => {
        //  this.$refs.audio.src = require("/audio/alarm.mp3");

        this.$refs.audio.currentTime = 0; //从头开始播放提示音
        this.$refs.audio.play(); //播放
      });
    },
    playMusic2() {
      this.$nextTick(() => {
        // let audioPlay = document.getElementById("audio2");

        // audioPlay.play();

        // setTimeout(() => {
        //   audioPlay.pause();
        //   audioPlay.load();
        // }, 10);

        // this.$refs.audio2.currentTime = 0; //从头开始播放提示音
        this.$refs.audio2.play(); //播放

        setTimeout(() => {
          //30秒后停止播放
          this.stopMusic2();
        }, 1000 * 30);
      });
    },
    stopMusic2() {
      if (this.$refs.audio2) {
        this.$refs.audio2.pause(); //停止播放
      }
    },
    closeNotify() {
      this.showAlarmNotify = false;
      this.stopMusic2();
      if (window.viewer) {
        viewer.entities.remove(this.alarmEntity);
      }
    },
    getLevel: function (value) {
      let result = "";
      let AlerteLevelArr = this.AlerteLevelArr;
      AlerteLevelArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    getType: function (value) {
      let AlertTypeArr = this.AlertTypeArr;
      let result = "";
      AlertTypeArr.forEach((item) => {
        if (value == item.Extend1) {
          result = item.Description;
        }
      });
      return result;
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    close() {
      // this.showClose = false;
      this.warningId = "";
    },

    queryMonitor() {
      this.cameraId = this.deviceInfo.DeviceId;
      this.cameraName = this.deviceInfo.DeviceName;
      this.cameraIsOnline = this.deviceInfo.IsOnline;
      this.isSoSMonitorDialogVisible = true;
    },
    goDetailInfo() {
      this.closeNotify();
      let path = "";
      if (this.alarmInfo.AlertType == 13) {
        this.$router.push({
          path: "/plugin/seekHelp/UI/WaitingForHelpInfo",
          query: {
            Id: this.warningId,
            type: "edit",
            ProcessStatus: "0",
          },
        });
      } else {
        path = `/plugin/serviceAlarm/UI/ElaryWarningInfo?Id=${this.warningId}`;
        this.$router.push(path);
      }

      // this.close();

      this.$store.state.isShowWarningBox = false;
    },
    search() {
      let that = this;
      let ResourcesId = this.warningId;
      if (ResourcesId) {
        let searchInfo = {
          Id: ResourcesId,
        };
        that.center = [];
        new MyApis()
          .GetItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            that.alarmInfo = r;
            let levelStyle = "";

            if (that.alarmInfo.AlertType === "0") {
              that.deviceInfo = JSON.parse(that.alarmInfo.Content);
              that.alarmInfo.Content = "SOS报警——" + that.deviceInfo.DeviceName;
              that.alarmInfo.SourceDesc = "报警柱";
              if (
                that.deviceInfo.Longitude &&
                (that.deviceInfo.Latitude || that.deviceInfo.Laitude) &&
                that.deviceInfo.Longitude != "0" &&
                (that.deviceInfo.Latitude != "0" ||
                  that.deviceInfo.Laitude != "0")
              ) {
                that.center.push(that.deviceInfo.Longitude);
                that.center.push(
                  that.deviceInfo.Latitude || that.deviceInfo.Laitude
                );
                that.isHavePosition = true;
              } else {
                that.isHavePosition = false;
              }
            } else {
              if (
                that.alarmInfo.Longitude &&
                (that.alarmInfo.Latitude || that.alarmInfo.Laitude) &&
                that.alarmInfo.Longitude != "0" &&
                (that.alarmInfo.Latitude != "0" ||
                  that.alarmInfo.Laitude != "0")
              ) {
                that.center.push(that.alarmInfo.Longitude);
                that.center.push(
                  that.alarmInfo.Latitude || that.alarmInfo.Laitude
                );
                that.isHavePosition = true;
              } else {
                that.isHavePosition = false;
              }
            }
            if (
              that.alarmInfo.AlertType == 20 ||
              that.alarmInfo.AlertType == 23
            ) {
              let content = that.alarmInfo.Content;
              content = content.substring(
                content.indexOf("【") + 1,
                content.indexOf("】")
              );
              if (content) {
                this.findEquip(content, that.alarmInfo);
              }
              return;
            }
            if (that.alarmInfo?.AlerteLevel == 10 && !that.isEmergency) {
              this.showAlarmNotify = true;
              this.showCesiumMapAlert(true);
              this.playMusic2();
              return;
            } else if (that.alarmInfo?.AlerteLevel == 7) {
              levelStyle = "style='background-color:orange'>";
            } else if (that.alarmInfo?.AlerteLevel == 5) {
              levelStyle = "style='background-color:yellow'>";
            } else {
              levelStyle = "style='background-color:blue'>";
            }
            const alarmTypeName = this.getType(that.alarmInfo?.AlertType);
            if (
              levelStyle &&
              alarmTypeName &&
              that.alarmInfo.Content &&
              !that.isEmergency
            ) {
              this.showCesiumMapAlert(false);
              this.showNotify(
                levelStyle,
                alarmTypeName,
                that.alarmInfo.Content
              );
            }
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    findEquip(deviceName, alarmInfo) {
      let params = {
        id: this.msgId,
        page: 1,
        size: 10,
        typeOneCode: "environmental_monitor",
        name: deviceName,
        model: "dustNoiseDevice",
      };
      const that = this;

      queryDevice(params).then((res) => {
        if (res && res.data.length > 0) {
          that.center = [];
          if (res.data[0].longitude && res.data[0].latitude) {
            that.center.push(res.data[0].longitude);
            that.center.push(res.data[0].latitude);
            that.isHavePosition = true;
            let levelStyle = "";
            if (alarmInfo?.AlerteLevel == 10 && !that.isEmergency) {
              this.showAlarmNotify = true;
              this.showCesiumMapAlert(true);
              this.playMusic2();
            } else if (alarmInfo?.AlerteLevel == 7) {
              levelStyle = "style='background-color:orange'>";
            } else if (alarmInfo?.AlerteLevel == 5) {
              levelStyle = "style='background-color:yellow'>";
            } else {
              levelStyle = "style='background-color:blue'>";
            }
            const alarmTypeName = this.getType(alarmInfo?.AlertType);
            if (
              levelStyle &&
              alarmTypeName &&
              alarmInfo.Content &&
              !that.isEmergency
            ) {
              this.showCesiumMapAlert(false);
              this.showNotify(levelStyle, alarmTypeName, alarmInfo.Content);
            }
          }
        }
      });
    },
    showCesiumMapAlert(val) {
      if (window.viewer) {
        //id为添加实体时的id名称
        let entID = window.viewer.entities.getById("alarmentity");
        if (entID) {
          window.viewer.entities.remove(entID);
        }

        // 波纹圆特效
        this.alarmEntity = window.viewer.entities.add({
          id: "alarmentity",
          position: Cesium.Cartesian3.fromDegrees(
            Number(this.center[0]),
            Number(this.center[1])
          ),
          name: "波纹圆",
          ellipse: {
            semiMinorAxis: 1000.0,
            semiMajorAxis: 1000.0,
            material: new Cesium.CircleRippleMaterialProperty({
              color: new Cesium.Color(1.0, 0.0, 0.0, 1),
              speed: 24.0,
              count: 4,
              gradient: 0.6,
            }),
          },
        });

        //强提醒才会挪到事发地
        if (val) {
          window.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(
              Number(this.center[0]),
              Number(this.center[1]),
              9493.719
            ),
          });
        }
      }
    },

    //日期列表展示格式
    formatDate(value) {
      // 获取单元格数据
      let data = value;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    alarmLevel() {
      //预警级别
      this.config
        .getUValue("BusinessAlarm:AlertLevel", "")
        .then((d) => {
          this.AlerteLevelArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("AlarmSubsystem:AlarmType", "")
        .then((d) => {
          this.AlertTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
  },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
  },
};
</script>
<style lang="scss" scoped>
.backYellow {
  background-color: yellow;
}
.backBlue {
  background-color: blue;
}
.backOrange {
  background-color: orange;
}

.cusNotify {
  background-color: rgba(7, 78, 133, 1);
  border: 1px solid #3778c0;
  width: 40rem;

  .el-notification__group {
    width: 100%;
  }
}

.alertNotify {
  background-color: rgba(7, 78, 133, 1);
  border: 1px solid #3778c0;
  width: 40rem;
  height: 8rem;
  position: fixed;
  left: calc(50% - 50px);
  top: calc(50% - 50px);
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 1.4rem 2.6rem 1.4rem 1.3rem;
  border-radius: 0.8rem;
  box-sizing: border-box;
  position: fixed;

  transition: opacity 0.3s, transform 0.3s;
  overflow: hidden;
  font-size: 1.4rem;
}
.cusNotifyBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.notifyLevel {
  width: 35px;
  height: 20px;
  background-color: #2ac1ff;
}
.notifyType {
  // width: 100px;
  margin: 0 10px;
  white-space: nowrap;
}
.notifyContent {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.notifyGroup {
  margin-left: 1.3rem;
  margin-right: 0.8rem;
  width: 100%;
}
.closebtn {
  position: absolute;
  top: 7px;
  right: 15px;
  cursor: pointer;
  color: #cccccc;
  font-size: 1.6rem;
}
.closebtn::before {
  content: "\e6db";
}
.backRed {
  background-color: red;
}
</style>